import React from "react"

import { getCxFromStyles } from "../../helpers"

import Button from "../Button"

import * as styles from "./Lead.module.scss"
import leadImage from "../../assets/agency-lead.png"
import leadChart from "../../assets/hotel-chart.svg"

const Lead = ({ goToContact }) => {
  const cx = getCxFromStyles(styles)

  return (
    <div className={cx("root", "not_contained")}>
      <div className={cx("container", "contained")}>
        <h1 className={cx("title")}>
          Smooth sales
          <br /> with error-free
          <br /> rate descriptions
        </h1>

        <img
          className={cx("right_image")}
          src={leadImage}
          alt="Illustration of travel agency rate verification"
          loading="eager"
          decoding="async"
        />

        <div className={cx("subtitle")}>
          <strong>Rate Cleaner</strong> equips travel agencies to quickly
          identify
          <br /> and correct inaccuracies in GDS rate descriptions,
          <br /> ensuring flawless bookings and stronger partnerships
          <br /> with hotels, ultimately driving more sales.
        </div>

        <div className={cx("button_container")}>
          <Button onClick={goToContact} button="primary_extra" color="green">
            Get Free Trial
          </Button>
        </div>
      </div>
      <div className={cx("chart_container")}>
        <img
          src={leadChart}
          alt="Chart illustration of booking performance growth"
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  )
}

export default Lead
